<template>
    <div class="team-detail">
        <content-header>
            <div class="header-left-box" slot="header-left">
                <div class="return-prev" @click="retuenPrev">
                    <span class="icon-box">
                        <span class="el-icon-arrow-left"></span>
                    </span>
                    <span class="return-text">{{ $t('teamDetail.FH') }}</span>
                </div>
                <content-header-title>
                    <span>{{ $t('teamDetail.TDXQ') }}</span>
                </content-header-title>
            </div>
            <div class="header-left-box" slot="header-right">
                <el-button type="primary" v-if="isbtn.btnEntryPractise" @click="goRace" size="small">
                    {{ $t('teamDetail.JRLX') }}</el-button>
                <!-- v-if="teamData.btnResetMatchFlag == 1" -->
                <el-button type="primary" @click="resetMatch('reset')" v-auth="[['teacher', 'student'], 'pro']"
                    v-if="isbtn.btnResetPractise" size="small">
                    {{ $t('teamDetail.CZLX') }}
                </el-button>
                <el-button type="primary" @click="resetMatch('start')" v-if="isbtn.btnOpenPractise" size="small">
                    {{ $t('teamDetail.KTLX') }}</el-button>
                <!-- v-show="__userData.userType > 1" v-else -->
            </div>
        </content-header>
        <div class="main">
            <content-left :teamData="isStudentLogin ? teamData.teamDto : teamData" :btnStatus="isbtn">
            </content-left>
            <div class="content-right">
                <div>
                    <tableTitle>
                        <div class="header-left" slot="header-left">
                            {{ $t('teamDetail.CYXX') }}
                        </div>
                        <div class="header-right" slot="header-right">
                            <div v-if="!edit">
                                <el-button type="danger" size="small" @click="teamDelete" v-if="isbtn.btnDeleteTeam">
                                    {{ $t('teamDetail.CCTD') }}</el-button>
                                <el-button type="primary" size="small" v-if="isbtn.btnEditTeam" @click="edit = true">
                                    {{ $t('teamDetail.BJTD') }}</el-button>
                            </div>
                            <div v-else>
                                <el-button size="small" @click="edit = false; getData()">{{ $t('teamDetail.QX') }}
                                </el-button>
                                <el-button type="primary" size="small" @click="saveTeam">{{ $t('teamDetail.BC') }}
                                </el-button>
                            </div>
                        </div>
                    </tableTitle>
                    <div class="table-box">
                        <c-table @operation="operation" :tableData="teamData.memberList" :ISChangeCheckout="false"
                            :edit="edit" :tableHeader="userTableHeader" :TableHeight="`calc(99%)`">
                        </c-table>
                    </div>
                </div>
                <div>
                    <tableTitle>
                        <div class="header-left" slot="header-left">
                            {{ $t('teamDetail.LXJL') }}
                        </div>
                    </tableTitle>
                    <div class="table-box">
                        <c-table @operation="operation" :tableData="teamData.subVersionLogList"
                            :ISChangeCheckout="false" :tableHeader="lxTableHeaderFilter" :TableHeight="`calc(99%)`">
                        </c-table>
                    </div>
                </div>
            </div>
        </div>
        <dialog-add-student ref="dialogAddStudent" @saveClick="saveClick"></dialog-add-student>
    </div>
</template>
<script>
import contentLeft from '@/views/teamDetail/content-left'
import tableTitle from '@/views/teamDetail/table-title'
import mins from '@/views/teamDetail/mins'
import CTable from '@/components/table'
import fetch from '@/api/fetch'
import {setStore} from '@/utils/common.js'
import dialogAddStudent from '@/views/teamDetail/dialog-add-student'
import { Base64 } from 'js-base64'
export default {
    name: 'teamDetail',
    components: {
        contentLeft,
        tableTitle,
        CTable,
        dialogAddStudent
    },
    mixins: [mins],
    data() {
        return {
            isStudentLogin: false
        }
    },
    created() {
        this.isStudentLogin = this.teamId === 'false' || !this.teamId
        this.getData()
    },
    computed: {
        isbtn() {
            try {
                return this.isStudentLogin ? this.teamData.pageBtnStatusDto.btnInnerStatus : JSON.parse(Base64.decode(this.$route.query.q)).btn
            } catch {
                return {}
            }
        },
        queryData() {
            return JSON.parse(sessionStorage.getItem('queryData'))
        }
    },
    methods: {
        retuenPrev() {
            if (this.__userData.userType < 2) {
                let planLxDetailUrl = JSON.parse(sessionStorage.getItem('planLxDetailUrl'))
                this.$router.push(planLxDetailUrl)
            } else {
                let planHomeUrl = JSON.parse(sessionStorage.getItem('planHomeUrl'))
                this.$router.push(planHomeUrl)
            }
        },
        getData() {
            let funName = this.isStudentLogin ? 'entryShow' : 'teamDetail'
            let params = {
                planId: this.planId,
                teamId: this.teamId
            }
            if (funName !== 'teamDetail') {
                delete params.teamId
            }
            fetch[funName](params).then(res => {
                if (res.code == 0) {
                    this.teamData = res.data
                    this.isStudentLogin ? setStore('isOpenPaperCopy', res.data.planDto.isOpenPaperCopy.toString()) : false
                    this.teamData.memberList = res.data[funName === 'teamDetail' ? 'memberList' : 'playerList'].map((item, index) => ({
                        index: ++index,
                        leaderFlagName:
                            item.leaderFlag == 1 ? this.$t('teamDetail.DZ') : this.$t('teamDetail.DY'),
                        stationAddId: item.stationId,
                        stationPrevId: item.stationId,
                        ...item
                    }))
                    this.teamData.subVersionLogList = res.data.subVersionLogList.map((item) => ({
                        startTimeSubmitTime: item.startTime + ' - ' + item.submitTime, ...item,
                        totalScore: Number(item.totalScore).toFixed(2)
                    }))
                }else{
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg , type: 'error' });
                    this.$router.go(-1)
                }
            })
        },
        operation(type, rowData, index) {

            if (type === 'show') {
                let pattern_operation = JSON.parse(Base64.decode(this.$route.query.q))
                let params = {
                    pattern_lx: pattern_operation.pattern_lx,
                    planId: rowData.planId,
                    keyId: rowData.id,
                    teamId: rowData.teamId,
                    answerFlag: pattern_operation.answerFlag,
                    mainVersion: rowData.mainVersion,
                    subVersion: rowData.subVersion
                }
                let params_jam = Base64.encode(JSON.stringify(params))
                sessionStorage.setItem('teamDetailUrl', JSON.stringify(this.$route.fullPath))
                this.$router.push(`/showLxRecord?q=${params_jam}`)
            } else if (type === 'addRemoveStudent') {
                // 清除或添加学生
                if (rowData.playerName) {
                    // 清除学生
                    let item = this.teamData.memberList[this.teamData.memberList.findIndex((item) => item.stationId === rowData.stationId)]
                    item.playerName = '',
                        item.playerNo = '',
                        item.playerId = '',
                        item.userId = '';
                } else {
                    // console.log(rowData.index - 1);
                    this.tableActiveIndex = rowData.index - 1
                    this.$refs['dialogAddStudent'].dialogData.addLxDialog = true
                }
            } else if (type === 'stationIdChange') {
                let i = 0;
                let findindex = this.teamData.memberList.findIndex(item => item.stationAddId === rowData.stationAddId) // 切换目标岗位
                if (findindex === index) {
                    findindex = this.teamData.memberList.findIndex(item => { if (item.stationAddId === rowData.stationAddId) { if (i) { return true } else { i++ } } }) // 切换目标岗位
                }
                let item = this.teamData.memberList[findindex]
                item.stationAddId = rowData.stationPrevId
                rowData.stationPrevId = rowData.stationAddId
                item.stationPrevId = item.stationAddId

            }
        },
        resetMatch(type) {
            let configData = {
                confirmText: type === 'reset' ? this.$t('teamDetail.SFQRCZLX') :
                    this.$t('teamDetail.SFQRCZLX') + sessionStorage.getItem('initInterval') + this.$t('teamDetail.FZCKYJX'),
                funName: type === 'reset' ? 'matchReset' : 'matchOpen',
                msgName: type === 'reset' ? this.$t('teamDetail.CZ') : this.$t('teamDetail.KT')
            }
            let funAxiosNext = () => {
                fetch[configData.funName]({
                    planId: this.planId,
                    teamId: this.teamData.teamDto.teamId
                }).then(res => {
                    if (res.code == 0) {
                        this.getData()
                        this.$notify({ title: this.$t('teamDetail.operation'), message: configData.msgName + this.$t('teamDetail.CG'), type: 'success' });
                    } else {
                        this.$notify({ title: this.$t('teamDetail.operation'), message: res.msg || this.$t('teamDetail.SB'), type: 'error' });
                    }
                })
            }
            // 重置练习 or 重置练习
            if ([8, 26].includes(this.queryData.professionId)) {
                funAxiosNext()
            } else {
                this.$confirm(configData.confirmText, this.$t('teamDetail.TS'), {
                    confirmButtonText: this.$t('teamDetail.QD'),
                    cancelButtonText: this.$t('teamDetail.QX'),
                    type: 'warning'
                }).then(() => {
                    funAxiosNext()
                })
            }

        },
        goRace() {
            // 解密存储本地
            let planData = JSON.parse(Base64.decode(this.$route.query.q))
            localStorage.setItem('pattern_lx', planData.pattern_lx)
            let { pattern_lx, schemeId, answerFlag, scoreFlag } = planData
            let { orgId, planId, mainVersion, subVersion, teamId } = this.teamData.teamDto
            let params = {
                dev: true,
                pattern_lx,
                planId: planId,
                orgId: orgId,
                mainVersion: mainVersion,
                subVersion: subVersion,
                userId: this.__userData.userId,
                teamId: teamId,
                schemeId,
                answerFlag,
                scoreFlag
            }
            this.getPlayerInfo(params)

        },
        getPlayerInfo(params) {
            let params_jam = Base64.encode(JSON.stringify(params))
            fetch.racePlayerDetail(params).then(res => {
                if (res.data.initStatus <= 1) {
                    this.$confirm(this.$t('teamDetail.BCLXZTSJ'), this.$t('teamDetail.TS'), {
                        confirmButtonText: this.$t('teamDetail.QD'),
                        cancelButtonText: this.$t('teamDetail.QX'),
                        type: 'warning'
                    }).then(() => {
                        this.goRaceHome(params, params_jam, res)
                    }).catch(() => { });
                } else {
                    this.goRaceHome(params, params_jam, res)
                }
            })
        },
        goRaceHome(params, params_jam, res) {
            if (this.$route.path === '/examHome') {
                return false
            }
            localStorage.setItem('matchPlanId', params.planId)
            localStorage.setItem('playerInfo', JSON.stringify(res.data))
            localStorage.setItem('resultVal', JSON.stringify(res.data))
            sessionStorage.setItem('prevUrl', location.href.split('/#/')[1])
            localStorage.setItem("isOpenFile", this.teamData.planDto.isOpenFile ? this.teamData.planDto.isOpenFile : 0);
            let url = `/examHome?q=${params_jam}`
            this.$router.push(url)
        },
        saveClick(rowData) {
            let item = this.teamData.memberList[this.tableActiveIndex];
            console.log(this.teamData.memberList[this.tableActiveIndex].playerName);
            item.playerName = rowData.playerName,
                item.playerNo = rowData.playerNo,
                item.playerId = rowData.playerId,
                item.userId = rowData.userId;
            console.log(this.teamData.memberList[this.tableActiveIndex].playerName);
        },
        teamDelete() {
            this.$confirm(this.$t('teamDetail.SFQRSCGTD'), this.$t('teamDetail.TS'), {
                confirmButtonText: this.$t('teamDetail.QD'),
                cancelButtonText: this.$t('teamDetail.QX'),
                type: 'warning'
            }).then(() => {
                fetch.teamDelete({
                    planId: this.planId,
                    teamId: this.teamId,  // --团队id
                }).then(res => {
                    if (res.code == 0) {
                        this.$router.go(-1)
                        this.$notify({ title: this.$t('teamDetail.operation'), message: this.$t('teamDetail.CZCG'), type: 'success' });
                    } else {
                        this.$notify({ title: this.$t('teamDetail.operation'), message: res.msg || this.$t('teamDetail.CZSB'), type: 'error' });
                    }
                })
            }).catch(() => { });
        },
        saveTeam(teamName) {

            let params = {
                planId: this.planId,
                teamId: this.isStudentLogin ? this.teamData.teamDto.teamId : this.teamId,  // --团队id
                teamName: typeof teamName === 'string' ? teamName : this.isStudentLogin ? this.teamData.teamDto.teamName : this.teamData.teamName,  // --团队名称
                imgUrl: this.isStudentLogin ? this.teamData.teamDto.imgUrl : this.teamData.imgUrl,  // --团队logo
                teamPlayerList: this.teamData.memberList.map((item) => {
                    return {
                        keyId: item.keyId,
                        playerId: item.playerId,
                        userId: item.userId,
                        stationId: item.stationAddId,
                        leaderFlag: item.leaderFlag
                    }
                })
            }
            fetch.teamUpdate(params).then(res => {
                if (res.code == 0) {
                    this.edit = false
                } else {
                    this.$notify({ title: this.$t('teamDetail.operation'), message: res.msg || this.$t('teamDetail.CZSB'), type: 'error' });
                    this.edit = false
                }
                this.getData()
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.header-left-box {
    display: flex;

    .return-prev {
        cursor: pointer;
        color: #858C96;

        .icon-box {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #B4BBCD;
            opacity: 0.2;
            text-align: center;
            line-height: 18px;
            font-size: 14px;
            color: #000;
            display: inline-block;
            vertical-align: 1px;
        }

        .return-text {

            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            letter-spacing: 1px;
            margin: 0 14px 0 6px;
            vertical-align: 1px;
        }
    }

    .return-prev:hover {
        color: #5397F7;

        .icon-box {
            color: #5397F7;
            opacity: .5;
        }
    }
}

.main {
    display: flex;
    padding: 10px 24px;
    box-sizing: border-box;
    justify-content: space-between;
    height: calc(100vh - 164px);
}

.content-right {
    display: flex;
    width: calc(100% - 420px);
    flex-direction: column;
    height: 100%;

    // overflow: auto;
    >div {
        flex: 1;

        .table-box {
            height: calc(100% - 40px);
        }
    }
}
</style>